<script>
import { WarrantyOrderDocumentMixin } from '@/components/service/WarrantyOrderDocument'

export default {
  mixins: [WarrantyOrderDocumentMixin],

  data() {
    return {
      form: {
        partServiceEmployeeName: '',
        mechanicName: '',
        date: '',
        orderId: '',
        index: '',
        damageCausingPart: '',
        makerCode: '',
        damageLocations: [],
        damageTypes: [],
        documents: [],
        miscellaneousDocumentLine1: '',
        miscellaneousDocumentLine2: '',
        breakdown: [],
        damageCausingPartReleasePage1: '',
        damageCausingPartReleasePage2: '',
        internalComment: ''
      },
      damageLocations: [
        { id: 'right', label: 'rechts' },
        { id: 'left', label: 'links' },
        { id: 'front', label: 'vorne' },
        { id: 'back', label: 'hinten' },
        { id: 'twoDoors', label: '2-türig' },
        { id: 'fourDoors', label: '4-türig' }
      ],
      damageTypes: [
        { id: 10, label: 'mechanischer Fehler' },
        { id: 11, label: 'Einstellfehler' },
        { id: 12, label: 'falsches Serienteil' },
        { id: 13, label: 'unrund/unwucht' },
        { id: 14, label: 'verbrannt/rutscht' },
        { id: 15, label: 'gerissen/gebrochen' },
        { id: 16, label: 'unwirksam' },
        { id: 17, label: 'schwergängig/klemmt' },
        { id: 18, label: 'leichtgängig/lose' },
        { id: 20, label: 'Geräusche' },
        { id: 21, label: 'Crimp am Kontakt' },
        { id: 22, label: 'Kontakt/Stecker' },
        { id: 23, label: 'Kontakt zurückgedrückt' },
        { id: 24, label: 'Leitung eingeklemmt' },
        { id: 25, label: 'Leitung angescheuert' },
        { id: 26, label: 'Leitungsknoten' },
        { id: 27, label: 'elektr. Schraubverbindung' },
        { id: 28, label: 'Steckergehäuse' },
        { id: 29, label: 'Leitungsverlegung (zu kurz/zu lang)' },
        { id: 30, label: 'optische Schäden' },
        { id: 31, label: 'verfärbt' },
        { id: 32, label: 'wellig' },
        { id: 33, label: 'korrodiert' },
        { id: 37, label: 'Schaden nicht reproduzierbar' },
        { id: 38, label: 'fehlendes Serienteil' },
        { id: 39, label: 'Softwarefehler' },
        { id: 40, label: 'elektrischer Fehler/GFS erforderlich' },
        { id: 49, label: 'Geruch' },
        { id: 50, label: 'undicht' },
        { id: 51, label: 'Windgeräusche' },
        { id: 56, label: 'Kraftstoffverbrauch' },
        { id: 61, label: 'schwarzer Rauch' }
      ]
    }
  },

  created() {
    this.$set(this.form, 'mechanicName', `${this.authUser.item_firstname} ${this.authUser.item_lastname}`)
    this.$set(this.form, 'date', this.today)
  },

  methods: {
    onOrderPanelExpanded() {
      this.focusInputRef('partServiceEmployeeNameInputRef')
    },

    onDamageCausingPartReleasePanelExpanded() {
      this.focusInputRef('damageCausingPartReleasePage1InputRef')
    },

    getSubmittableData() {
      return {
        ...this.form,
        breakdown: [...this.form.breakdown].filter(item => !!item.description || !!item.mechanicId || !!item.timeTracking)
      }
    }
  }
}
</script>

<template>
  <div>
    <mia-expandable-panel
      title="Auftragsdaten"
      is-expanded
      @expanded="onOrderPanelExpanded"
    >
      <div class="grid grid-cols-12 gap-4 p-4">
        <!-- partServiceEmployeeName -->
        <div class="col-span-3 flex items-center">
          <label
            for="partServiceEmployeeNameInput"
            class="tracking-wider text-gray-800"
          >
            Name Teiledienst-Mitarbeiter
          </label>
        </div>
        <div class="col-span-9">
          <mia-feature-input
            id="partServiceEmployeeNameInput"
            ref="partServiceEmployeeNameInputRef"
            v-model="form.partServiceEmployeeName"
          />
        </div>

        <!-- mechanicName -->
        <div class="col-span-3 flex items-center">
          <label
            for="mechanicName"
            class="tracking-wider text-gray-800"
          >
            Name Monteur
          </label>
        </div>
        <div class="col-span-9">
          <mia-feature-input
            id="mechanicName"
            v-model="form.mechanicName"
          />
        </div>

        <!-- date -->
        <div class="col-span-3 flex items-center">
          <label
            for="date"
            class="tracking-wider text-gray-800"
          >
            Datum
          </label>
        </div>
        <div class="col-span-9">
          <mia-feature-input
            id="date"
            v-model="form.date"
            type="date"
          />
        </div>

        <!-- orderId -->
        <div class="col-span-3 flex items-center">
          <label
            for="orderId"
            class="tracking-wider text-gray-800"
          >
            Auftragsnummer
          </label>
        </div>
        <div class="col-span-3">
          <mia-feature-input
            id="orderId"
            v-model="form.orderId"
          />
        </div>

        <!-- index -->
        <div class="col-span-3 flex items-center justify-end">
          <label
            for="index"
            class="tracking-wider text-gray-800"
          >
            Index
          </label>
        </div>
        <div class="col-span-3">
          <mia-feature-input
            id="index"
            v-model="form.index"
          />
        </div>

        <!-- damageCausingPart -->
        <div class="col-span-3 flex items-center">
          <label
            for="damageCausingPart"
            class="tracking-wider text-gray-800"
          >
            Schaden verursachendes Teil
          </label>
        </div>
        <div class="col-span-3">
          <mia-feature-input
            id="damageCausingPart"
            v-model="form.damageCausingPart"
          />
        </div>

        <!-- makerCode -->
        <div class="col-span-3 flex items-center justify-end">
          <label
            for="makerCode"
            class="tracking-wider text-gray-800"
          >
            Herstellercode
          </label>
        </div>
        <div class="col-span-3">
          <mia-feature-input
            id="makerCode"
            v-model="form.makerCode"
          />
        </div>
      </div>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Schadensort"
      is-expanded
      class="mt-4"
    >
      <div class="p-4">
        <div class="grid grid-cols-4 gap-4">
          <label
            v-for="damageLocation in damageLocations"
            :key="damageLocation.id"
            class="flex items-center font-normal"
          >
            <mia-checkbox
              :checked="form.damageLocations.includes(damageLocation.id)"
              class="w-5 h-5"
              @change="onDamageLocationChange(damageLocation, $event)"
            />
            <span class="ml-2">{{ damageLocation.label }}</span>
          </label>
        </div>
      </div>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Fehlerfeststellung am Schaden verursachenden Bauteil aus technischer Sicht"
      is-expanded
      class="mt-4"
    >
      <div class="p-4 grid grid-cols-3 gap-x-4 gap-y-2">
        <label
          v-for="damageType in damageTypes"
          :key="damageType.id"
          class="flex items-center font-normal"
        >
          <mia-checkbox
            :checked="form.damageTypes.includes(damageType.id)"
            class="w-5 h-5"
            @change="onDamageTypeChange(damageType, $event)"
          />
          <span class="ml-2">{{ damageType.id }} {{ damageType.label }}</span>
        </label>
      </div>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Wurden ggf. folgende Unterlagen berücksichtigt?"
      is-expanded
      class="mt-4"
    >
      <div class="p-4 grid grid-cols-3 gap-x-4 gap-y-2">
        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('gfsProtocolOnline')"
            class="w-5 h-5"
            @change="onDocumentChange('gfsProtocolOnline', $event)"
          />
          <span class="ml-2">
            GFS Diagnoseprotokoll online?
          </span>
        </label>

        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('batteryCheckProtocol')"
            class="w-5 h-5"
            @change="onDocumentChange('batteryCheckProtocol', $event)"
          />
          <span class="ml-2">
            Batterieprüfprotokoll
          </span>
        </label>

        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('miscellaneous')"
            class="w-5 h-5"
            @change="onDocumentChange('miscellaneous', $event)"
          />
          <span class="ml-2">
            Sonstiges:
          </span>
        </label>

        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('measurementProtocolsBeforeAfter')"
            class="w-5 h-5"
            @change="onDocumentChange('measurementProtocolsBeforeAfter', $event)"
          />
          <span class="ml-2">
            Vermessungsprotokolle vorher/nachher
          </span>
        </label>

        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('compressionCheck')"
            class="w-5 h-5"
            @change="onDocumentChange('compressionCheck', $event)"
          />
          <span class="ml-2">
            Kompressionsprüfung
          </span>
        </label>

        <div>
          <mia-feature-input
            v-if="form.documents.includes('miscellaneous')"
            v-model="form.miscellaneousDocumentLine1"
          />
        </div>

        <label class="flex items-center font-normal">
          <mia-checkbox
            :checked="form.documents.includes('climateControlProtocol')"
            class="w-5 h-5"
            @change="onDocumentChange('climateControlProtocol', $event)"
          />
          <span class="ml-2">
            Klimaanlagenprotokoll
          </span>
        </label>

        <div>&nbsp;</div>

        <div>
          <mia-feature-input
            v-if="form.documents.includes('miscellaneous')"
            v-model="form.miscellaneousDocumentLine2"
          />
        </div>
      </div>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Durchgeführte Arbeiten"
      is-expanded
      class="mt-4"
      @expanded="onBreakdownPanelExpanded"
    >
      <table class="w-full">
        <thead>
          <tr>
            <th class="p-2">
              Genaue Auflistung der durchgeführten Arbeiten bzw. Feststellungen (Prüf- und Messarbeiten)
            </th>
            <th class="p-2">
              Monteur-Nr.
            </th>
            <th class="p-2">
              ZE
            </th>
            <th class="p-2">
&nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in form.breakdown"
            :key="item.id"
          >
            <td class="p-2">
              <mia-feature-input
                :ref="`breakdownDescriptionRef${item.id}`"
                :value="item.description"
                @input="onBreakdownDescriptionInput(item, $event)"
              />
            </td>
            <td class="p-2">
              <mia-feature-input
                :value="item.mechanicId"
                @input="onBreakdownMechanicIdInput(item, $event)"
              />
            </td>
            <td class="p-2">
              <mia-feature-input
                :value="item.timeTracking"
                @input="onBreakdownTimeTrackingInput(item, $event)"
                @blur="onBreakdownTimeTrackingBlur(item, $event)"
              />
            </td>
            <td class="p-2">
              <button
                type="button"
                class="w-8 h-8 rounded inline-flex items-center justify-center hover:bg-red-500 hover:text-white focus:outline-none"
                @click="removeBreakdownItem(item)"
              >
                <mia-streamline-icon
                  class="w-5 h-5 fill-current"
                  src="bin-1"
                />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Abgabe des Schaden verursachenden Teiles"
      is-expanded
      class="mt-4"
      @expanded="onDamageCausingPartReleasePanelExpanded"
    >
      <div class="p-4">
        <mia-feature-input
          ref="damageCausingPartReleasePage1InputRef"
          v-model="form.damageCausingPartReleasePage1"
        />
        <mia-feature-input
          v-model="form.damageCausingPartReleasePage2"
          class="mt-4"
        />
      </div>
    </mia-expandable-panel>

    <mia-expandable-panel
      title="Intern"
      is-expanded
      class="mt-4"
      @expanded="onInternalPanelExpanded"
    >
      <div class="p-4">
        <mia-feature-textarea
          ref="internalCommentInputRef"
          v-model="form.internalComment"
          label="Kommentar (intern)"
        />
      </div>
    </mia-expandable-panel>
  </div>
</template>
